import React from "react";
import { Text } from "react-native-paper";
import { View } from "react-native";
import AccordionItem from "../AccordionItem";

const AccordionItemText = ({ styles, j, subSection }) => {
  return (
    <View style={{ paddingBottom: 10, paddingTop: 10 }}>
      <View style={styles.subSection} key={j}>
        <View style={styles.textdescriptionDesign}>
          <View style={{ alignItems: "flex-start" }}>
            <View style={{ flexDirection: "row" }}>
              <Text style={{ color: "#666" }}>{"\u2022"}</Text>
              <Text style={{ flex: 1, paddingLeft: 5, color: "#666" }}>
                {subSection.description1}
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.textdescriptionDesign}>
          <View style={{ alignItems: "flex-start" }}>
            <View style={{ flexDirection: "row" }}>
              <Text style={{ color: "#666" }}>{"\u2022"}</Text>
              <Text style={{ flex: 1, paddingLeft: 5, color: "#666" }}>
                {subSection.description2}
              </Text>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default AccordionItemText;
